<template>
  <div>
    <!--g插件-->
    <el-dialog
        v-if="clientType === 'g'"
        :visible.sync="dialogVisible"
        custom-class="no-header transparent-bg"
        :append-to-body="!modalAppendToBody"
        center
        width="400px"
    >
      <el-progress :percentage="percentage" :show-text="false" :stroke-width="12"></el-progress>
    </el-dialog>
    <!--r插件-->
    <el-dialog
        v-else
        title="选择族类型"
        :visible.sync="dialogVisible"
        :append-to-body="!modalAppendToBody"
        width="480px">
      <div class="component-type-content">
        <div class="download-progress">
          <div class="download-progress-bar">
            <el-progress :percentage="percentage" :show-text="false" :stroke-width="12"></el-progress>
          </div>
          <span :style="{ color: formatTextColor() }">{{format()}}</span>
        </div>
        <div class="select-type" v-if="this.parameterTypeOptions && this.parameterTypeOptions.length > 0 && clientType === 'r'">
          <span>选择族类型</span>
          <div class="select-items">
            <el-radio class="select-item-radio" v-model="radio" v-for="(parameterType, index) in parameterTypeOptions" :key="index" :label="parameterType.name">{{ parameterType.name }}</el-radio>
          </div>
          <el-checkbox v-model="checked" >同时载入全部族类型（等待时间可能变长）</el-checkbox>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
            <el-button @click="onCancel">取消</el-button>
            <el-button type="primary" :disabled="disabledPlace" @click="onPlace">布置</el-button>
        </span>
    </el-dialog>
  </div>

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { localCachePath, checkExistFile } from '@/core/desktopCache'

export default {
  name: 'PlaceholderTabContent',
  data() {
    return {
      dialogVisible: false,
      saveAsPath: '',
      percentage: 0,
      radio: '',
      checked: false,
      spaceId: null,
      resourceInfo: null,
      disabledPlace: true,
      progressStatus: null,
      modalAppendToBody: true,
      familyFoundStrategy: ''
    }
  },
  computed: {
    ...mapGetters({
      parameterTypeOptions: 'resourceDetail/parameterTypeOptions',
      versionResourceInfo: 'resourceDetail/versionResourceInfo',
      softwareCode: 'softwareCode',
      user: 'user/user',
      clientType: 'platform',
    })
  },
  methods: {
    ...mapActions({
      loadVersionResourceInfo: 'resourceDetail/loadVersionResourceInfo'
    }),
    checkedRadio() {
      this.radio = this.parameterTypeOptions && this.parameterTypeOptions.length > 0 ? this.parameterTypeOptions[0].name : ''
    },
    format() {
      return this.percentage === 100 && this.progressStatus === 'success' ? '下载完成' : this.progressStatus === 'exception' ? '下载失败' : '下载中'
    },
    formatTextColor() {
      switch (this.progressStatus) {
        case 'success':
          return '#009EE1'
        case 'exception':
          return '#FF4D4F'
        default:
          return ''
      }
    },
    async openDialog(spaceId, row, appendDialog = true, familyFoundStrategy) {
      this.dialogVisible = true
      this.percentage = 0
      this.progressStatus = null
      this.spaceId = spaceId
      this.resourceInfo = row
      this.modalAppendToBody = appendDialog
      this.familyFoundStrategy = familyFoundStrategy
      await this.loadVersionResourceInfo({
        space_id: spaceId,
        space_resource_id: row.spaceResourceId,
        resource_software_version_id: row.id,
      })
      if (this.clientType === 'r') {
        this.checkedRadio()
      }
      await this.download()
    },
    beforeDownload() {
      const catchPath = localCachePath()
      this.saveAsPath = `${catchPath}\\${this.versionResourceInfo.dataVersionId}`
      console.log('下载资源前获取插件下载地址, 保存路径：', this.saveAsPath)
      return checkExistFile(this.saveAsPath)
    },
    async download() {
      try {
        if (!this.beforeDownload()) {
          console.log('本地有缓存，跳过下载，精度条100')
          this.percentage = 100
          this.disabledPlace = false
          this.progressStatus = 'success'
          if (this.clientType === 'g') {
            this.onPlace()
          }
          return
        }
        this.percentage = 20
        await this.$api.resource.getDownloadUrl(this.spaceId, this.resourceInfo.spaceResourceId, this.versionResourceInfo.id, this.versionResourceInfo.dataVersionId).then(async(res) => {
          if (res) {
            this.percentage = 50
            try {
              await this.$desktopClient.DownloadFile(res, this.saveAsPath, true).then(() => {
                this.percentage = 100
                this.disabledPlace = false
                if (this.clientType === 'g') {
                  this.onPlace()
                }
                this.progressStatus = 'success'
              })
            } catch (err) {
              console.error(err)
              // this.percentage = 100
              this.progressStatus = 'exception'
              this.$message.error('获取下载地址失败')
            }
          } else {
            // this.percentage = 100
            this.progressStatus = 'exception'
            this.$message.error('获取下载地址失败')
          }
        })
      } catch (err) {
        console.log(err)
        this.progressStatus = 'exception'
        this.$message.error('下载失败')
      }
    },
    onCancel() {
      this.dialogVisible = false
      this.saveAsPath = ''
      this.percentage = 0
      this.radio = ''
      this.checked = false
      this.resourceInfo = null
      this.disabledPlace = true
      this.progressStatus = null
      this.parameterTypeOptions = []
    },
    onPlace() {
      try {
        this.$tracks({
          event: 'placeSpaceComponent',
          params: {
            g_c_space_id: this.spaceId,
            g_c_file_id: this.resourceInfo.spaceResourceId,
            g_c_fimaliy_type: this.radio
          }
        })
        const publicParams = {
          userId: this.user.strId,
          softwareVersionId: this.resourceInfo.softwareVersionId,
          dataVersionId: this.resourceInfo.dataVersionId,
          name: this.resourceInfo.name,
          suffix: this.resourceInfo.suffix,
          filePath: this.saveAsPath,
          typeNames: this.parameterTypeOptions && this.parameterTypeOptions.length > 0 ? this.parameterTypeOptions.map((m) => m.name) : '',
          familyFoundStrategy: this.familyFoundStrategy || 'FFS_CREATE'
        }

        const rParams = {
          ...publicParams,
          typeNameToBePlaced: this.radio,
          loadAllTypes: this.checked
        }
        const gParams = { ...publicParams }

        // 开启标题栏蒙层
        this.$desktopClient.PlaceComponent(this.clientType === 'r' ? rParams : gParams).then(() => {
          // 布置成功
          // 关闭标题栏蒙层
          this.onCancel()
        }).finally(() => {
        // 关闭标题栏蒙层
          this.dialogVisible = false
        })
      } catch (err) {
        // 布置失败
        console.error(err)
      }
    },
  }
}
</script>

<style lang="less" scoped>
  .component-type-content{
    .download-progress {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      .download-progress-bar {
        width: 83%;
      }
    }
    .select-type {
      margin-top: 12px;
      .select-items {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        background: @bg-grey-light;
        margin: 5px 0;
        .select-item-radio {
          padding: 10px;
        }
      }
    }
    .el-checkbox {
      font-weight: normal;
    }
  }
  .dialog1-footer{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
  .dialog1-tip{
    color: @text-main-gery;
  }
  /deep/ .el-radio__label {
    color: #495F70 !important;
  }
  /deep/ .el-checkbox__input.is-checked+.el-checkbox__label {
    color: #495F70 !important;
  }
</style>

